document.addEventListener("DOMContentLoaded", () => {
  const gallery = document.querySelector("media-gallery");
  if (!gallery) return;

  function getVisibleImages() {
    // Finds all <img> tags inside the active slideshow
    return gallery.querySelectorAll("media-gallery--slideshow img");
  }

  let images = getVisibleImages();
  if (images.length <= 1) return;

  let index = 0;
  let interval;

  function showImage(i) {
    images.forEach((img, idx) => {
      img.style.opacity = idx === i ? "1" : "0";
      img.style.transition = "opacity 0.6s ease";
      img.style.position = "absolute";
      img.style.top = "0";
      img.style.left = "0";
      img.style.width = "100%";
    });
  }

  function startRotation() {
    stopRotation();
    interval = setInterval(() => {
      index = (index + 1) % images.length;
      showImage(index);
    }, 4000);
  }

  function stopRotation() {
    clearInterval(interval);
  }

  // Initialize
  gallery.style.position = "relative";
  showImage(index);
  startRotation();

  // Pause on hover
  gallery.addEventListener("mouseenter", stopRotation);
  gallery.addEventListener("mouseleave", startRotation);

  // When variant changes, reload images and restart rotation
  document.addEventListener("variant:change", () => {
    setTimeout(() => {
      images = getVisibleImages();
      index = 0;
      if (images.length > 1) {
        showImage(index);
        startRotation();
      } else {
        stopRotation();
      }
    }, 50); // small delay to allow DOM to update
  });
});
